import { render, staticRenderFns } from "./Addproduct-ACC.vue?vue&type=template&id=792db69b"
import script from "./Addproduct-ACC.vue?vue&type=script&lang=js"
export * from "./Addproduct-ACC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports